export const useBrowserLocale = (): 'EN' | 'FR' | 'DE' | string => {
  const supportedLocales = ['EN', 'FR', 'DE']

  const firstSupportedLocale = navigator.languages.find((language) => {
    const shortLangCode = language.slice(0, 2).toUpperCase()
    return supportedLocales.find((supportedLanguage) =>
      supportedLanguage.includes(shortLangCode)
    )
  })

  return firstSupportedLocale?.slice(0, 2).toUpperCase() ?? 'EN'
}
